import React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import { colors } from '../../../theme/tokens';

const DARK = colors.textPrimary;

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    background: colors.bgSurface,
    borderRadius: 12,
    border: `1px solid ${colors.border}`,
    padding: '18px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    boxShadow: `0 1px 3px ${colors.shadow}`,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box' as any,
    cursor: (props: { clickable?: boolean }) =>
      props.clickable ? 'pointer' : 'default',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
      padding: '16px 12px',
      gap: 8,
    },
  },
  icon: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  num: { fontSize: 26, fontWeight: 800, color: DARK, lineHeight: 1 },
  label: {
    fontSize: 11,
    color: colors.textFaint,
    marginTop: 4,
    fontWeight: 600,
  },
  sub: { fontSize: 11, fontWeight: 700, marginTop: 2 },
}));

export interface KpiCardProps {
  icon: React.ComponentType<{ style?: React.CSSProperties }>;
  value: React.ReactNode;
  label: string;
  color?: string;
  bg?: string;
  sub?: string;
  subColor?: string;
  onClick?: () => void;
}

export default function KpiCard({
  icon: Icon,
  value,
  label,
  color = colors.brandStrong,
  bg = colors.brandTint,
  sub,
  subColor = colors.textMuted,
  onClick,
}: KpiCardProps) {
  const classes = useStyles({ clickable: !!onClick });
  return (
    <div className={classes.card} onClick={onClick}>
      <div className={classes.icon} style={{ background: bg }}>
        <Icon style={{ fontSize: 20, color }} />
      </div>
      <div style={{ minWidth: 0 }}>
        <div className={classes.num}>{value}</div>
        <div className={classes.label}>{label}</div>
        {sub && (
          <div className={classes.sub} style={{ color: subColor }}>
            {sub}
          </div>
        )}
      </div>
    </div>
  );
}
